<app-menu>
  <div class="desktop">
    <app-voltar class="back" />
    <div class="header">
      <app-titulo text="Ajuste de apontamento"></app-titulo>
    </div>
    <form #apontamentoHoraForm="ngForm" class="form">
      <app-input
        label="Nome do pessoa"
        type="select"
        name="nomePessoa"
        [required]="true"
        [requiredInput]="true"
        [selectData]="pessoaOptions"
        (ngModelChange)="changeSelect($event, 'nomePessoa')"
        [(ngModel)]="form.nomePessoa"
        [disabled]="!this.isMode"
      />
      <app-input
        type="date-hour"
        label="Data e hora entrada"
        name="dataEntrada"
        [requiredInput]="true"
        [(ngModel)]="form.dataEntrada"
      />
      <app-input
        type="date-hour"
        label="Data e hora saída almoço"
        name="dataSaidaAlmoco"
        [requiredInput]="true"
        [(ngModel)]="form.dataSaidaAlmoco"
      />
      <app-input
        type="date-hour"
        label="Data e hora retorno almoço"
        name="dataRetornoAlmoco"
        [requiredInput]="true"
        [(ngModel)]="form.dataRetornoAlmoco"
      />
      <app-input
        type="date-hour"
        label="Data e hora saída"
        name="dataSaida"
        [requiredInput]="true"
        [(ngModel)]="form.dataSaida"
      />
      <app-input
        type="date-hour"
        label="Data e hora entrada hora extra"
        name="dataEntradaHoraExtra"
        [(ngModel)]="form.dataEntradaHoraExtra"
      />
      <app-input
        type="date-hour"
        label="Data e hora saída hora extra"
        name="dataSaidaHoraExtra"
        [(ngModel)]="form.dataSaidaHoraExtra"
      />
      <app-input
        type="textarea"
        label="Descrição do apontamento"
        placeholder="Digite"
        name="descricaoMotivo"
        maxLength="150"
        [required]="true"
        [requiredInput]="true"
        class="grid-2fr"
        [(ngModel)]="form.descricaoMotivo"
      ></app-input>
    </form>
    <app-botao
      type="primario"
      text="Salvar apontamento"
      (click)="registrarApontamento()"
      *ngIf="permission === 1"
      [disabled]="validacaoForm() ? false : true"
    ></app-botao>
  </div>
</app-menu>

<app-loader *ngIf="loader" />
